import { getVal } from 'react-redux-firebase'
import { createSelector } from 'reselect'
import { EDITOR, NO_ACCESS, COMMENTER } from '../../constants'
import { authSelector, firebaseSelector } from './baseSelectors'
import { currentBoardIdSelector, currentFolderIdSelector } from './selectors'

/** @typedef {function} Selector */

/**
 * Get current users access list, bad data filtered out, anon-users set all to VIEWER
 * @param {Selector} firebaseSelector
 * @param {Selector} authSelector
 * @return {object} accessList
 */
export const accessListSelector = createSelector(
  [firebaseSelector, authSelector],
  (firebase, auth) => {
    if (auth) {
      const accessList = getVal(firebase, `access/${auth.uid}`)
      for (const item in accessList) {
        if (!accessList[item].id) {
          console.warn('Invalid item in accessList', item, accessList[item])
          delete accessList[item]
        }
        // anon users can only view
        if (
          auth.isAnonymous &&
          accessList[item] &&
          accessList[item].accessLevel > COMMENTER
        ) {
          accessList[item].originalAccessLevel = accessList[item].accessLevel
          accessList[item].accessLevel = COMMENTER
        }
      }
      return accessList
    }
  }
)

const getParentId = item =>
  item.parent || (item.folders && item.folders.length && item.folders[0].id)

export const getFoldersSelector = createSelector(
  [accessListSelector],
  accessList =>
    function getFolders(item) {
      if (!accessList) return
      const folders = []

      function addParent(item) {
        const parentId = getParentId(item)
        if (parentId) {
          const folder = accessList[parentId]
          if (folder) {
            if (folder.accessLevel) folders.unshift(folder)
            addParent(folder)
          }
        }
      }
      addParent(item)

      return folders
    }
)

export const getAccess = (itemId, accessList) => {
  if (!itemId || !accessList) return accessList
  return itemId in accessList ? accessList[itemId].accessLevel : NO_ACCESS
}

export const currentItemIdSelector = createSelector(
  [currentBoardIdSelector, currentFolderIdSelector],
  (boardId, folderId) => boardId || folderId
)

export const accessLevelSelector = createSelector(
  [currentItemIdSelector, accessListSelector],
  getAccess
)

export const editingItemSelector = state => state.sidebar.editingItem

export const sidebarDragSelector = state => state.sidebar.drag

/**
 * Get all the folders you could move a board or folder to
 * @return {object} moveList
 */
export const moveToSelector = createSelector(
  [accessListSelector, (state, itemId) => itemId],
  (accessList, itemId) => {
    const moveList = {}
    Object.values(accessList || {}).forEach(item => {
      // Exclude boards, archived and no permission
      if (
        item.type === 'board' ||
        item.id === itemId ||
        item.dateArchived ||
        !(item.accessLevel >= EDITOR)
      )
        return

      const addItem = item => {
        let parentId
        if (
          accessList[item.parent] &&
          accessList[item.parent].accessLevel >= EDITOR
        )
          parentId = item.parent
        if (!(parentId in moveList)) moveList[parentId] = []
        moveList[parentId].push(item)
      }
      addItem(item)

      // // make sure parent's parent is in the list
      // // (the user may have access to this but not its parent)
      // let parent = accessList[item.parent]
      // while (parent && !(parent.accessLevel >= EDITOR)) {
      //   addItem(parent)
      //   // casscade up
      //   parent = accessList[parent.parent]
      // }
    })
    return moveList
  }
)
